
import { I18n } from 'react-redux-i18n';
import toastr from 'toastr';

import store from './../../store';
import { unauth } from './authActions';

toastr.options = {
  progressBar: true,
  preventDuplicates: true,
  closeButton: true,
  positionClass: 'toast-bottom-right',
  showDuration: 300,
  hideDuration: 1000,
  timeOut: 0,
  extendedTimeOut: 1000,
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
};

export const showToast = (type, title, text) => {

  toastr.options.timeOut = 5000;
  toastr[type](title, text);

};


export const unauthToast = (type, title, text) => {

  toastr.options.timeOut = 0;
  toastr.options.onclick = () => {

    console.log('click')
    store.dispatch(unauth());

  };

  toastr[type](title, text);

};



// WEBPACK FOOTER //
// ./src/redux/actions/toastrActions.js